module.exports = __webpack_public_path__ + "media/images/homes/OrderHistoryReturns-b9c40fadadbe7be1626f7deaab4dd212.png";